import React, { useState, useEffect } from "react";
import { Container } from "reactstrap";
import * as url from "../../utils/urls";
import { apiReq } from "../../utils/utils";
import { useSelector } from "react-redux";
import { useForm } from "react-hook-form";
import Swal from "sweetalert2";
import S3FileUpload from "react-s3";
import { useHistory, useParams } from "react-router-dom";
import { CKEditor } from "@ckeditor/ckeditor5-react";
import ClassicEditor from "@ckeditor/ckeditor5-build-classic";
import { Select } from "antd";
import Loading from "../../components/Common/Loading";

function EditSocialNews(props) {
  const [categories, setCategories] = useState([]);
  const [image, setImage] = useState(null);
  const [content, setContent] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const [selectedCategory, setSelectedCategory] = useState([]);
  const {
    register,
    handleSubmit,
    watch,
    setValue,
    formState: { errors },
  } = useForm();
  const { id } = useParams();
  const history = useHistory();
  const user = useSelector((state) => state.User);
  const { Option } = Select;

  useEffect(() => {
    if (user?.user?.role?.title !== "Admin") {
      props.history.push("/dashboard");
    }
  }, []);

  // console.log("selectedCategory", selectedCategory);

  // Todo: get settings
  const getCategories = () => {
    setIsLoading(true);
    apiReq(url.GET_SOCIAL_CATEGORY, {}, "get", null)
      .then((res) => {
        if (res.success && res.data !== null) {
          setCategories(res.data);
        }
        setIsLoading(false);
      })
      .catch((err) => {
        setIsLoading(false);
        console.log("err>>>", err);
      });
  };

  useEffect(() => {
    getCategories();
    getSocialNewsItem();
  }, []);

  const config = {
    bucketName: process.env.REACT_APP_BUCKET_NAME,
    dirName: "news",
    region: "eu-central-1",
    accessKeyId: process.env.REACT_APP_ACCESS_ID,
    secretAccessKey: process.env.REACT_APP_ACCESS_SECRET,
  };

  // Handle Cnahge Category
  const handleChangeCategory = (value) => {
    setSelectedCategory(value);
  };

  // HandleImageUpload
  const handleLogoUpload = (event) => {
    const file = event.target.files[0];

    S3FileUpload.uploadFile(file, config)
      .then((data) => {
        setImage(
          `https://${config.bucketName}.s3.${config.region}.amazonaws.com/${data.key}`
        );
      })
      .catch((err) => console.log(err));
  };

  // Todo: get social news item details
  const getSocialNewsItem = () => {
    setIsLoading(true);
    apiReq(url.DETAILS_SOCIAL_NEWS_ITEMS + id, {}, "get", null)
      .then((res) => {
        if (res.success && res.data !== null) {
          setSelectedCategory(res.data.category.map((cat) => cat._id));
          setValue("title", res.data.title);
          // setValue("category", res.data.category._id);
          setValue("description", res.data.description);
          setValue("meta_title", res.data.meta_title);
          setValue("meta_description", res.data.meta_description);
          setImage(res.data.image);
          setContent(res.data.content);
        }
        setIsLoading(false);
      })
      .catch((err) => {
        setIsLoading(false);
        console.log("err>>>", err);
      });
  };

  const slugify = (text) => {
    const from = "ãàáäâẽèéëêìíïîõòóöôùúüûñç·/_,:;";
    const to = "aaaaaeeeeeiiiiooooouuuunc------";

    const newText = text
      .split("")
      .map((letter, i) =>
        letter.replace(new RegExp(from.charAt(i), "g"), to.charAt(i))
      );

    return newText
      .toString() // Cast to string
      .toLowerCase() // Convert the string to lowercase letters
      .trim() // Remove whitespace from both sides of a string
      .replace(/\s+/g, "-") // Replace spaces with -
      .replace(/&/g, "-y-") // Replace & with 'and'
      .replace(/[^\w\-]+/g, "") // Remove all non-word chars
      .replace(/\-\-+/g, "-"); // Replace multiple - with single -
  };

  // Todo: onSubmit
  const onSubmit = (data) => {
    if (image === null) {
      Swal.fire({
        icon: "error",
        title: "Oops...",
        text: "Please Upload Image",
      });
      return;
    } else {
      setIsLoading(true);
      apiReq(
        url.UPDATE_SOCIAL_NEWS_ITEMS + id,
        {
          title: data.title,
          description: data.description,
          category: selectedCategory,
          image: image,
          slug: slugify(data.title),
          content: content,
          meta_title: data.meta_title,
          meta_description: data.meta_description,
        },
        "put",
        {
          Authorization: `Bearer ${user.user?.token}`,
        }
      )
        .then((res) => {
          if (res.success && res.data !== null) {
            history.push("/social/list");
            Swal.fire({
              title: "Success",
              text: res.message,
              icon: "success",
              showConfirmButton: false,
              timer: 1500,
            });
          }
          setIsLoading(false);
        })
        .catch((err) => {
          setIsLoading(false);
          console.log("err>>>", err);
        });
    }
  };

  return (
    <React.Fragment>
      <div className="page-content">
        {isLoading && <Loading />}
        <Container fluid>
          <div className="card">
            <div className="card-body">
              <h5 className="card-title">Edit Social News</h5>
              <hr />
              <form onSubmit={handleSubmit(onSubmit)}>
                <div className="row">
                  <div className="col-md-4">
                    <div className="mb-3">
                      <label>Image</label>
                      <div
                        className="dropzone p-4 mb-3"
                        style={{ minHeight: 120 }}
                      >
                        {!image ? (
                          <div
                            className="needsclick"
                            // {...getRootProps()}
                          >
                            {/* <input /> */}
                            <div className="mb-3">
                              <i className="ri-image-line display-4 text-muted"></i>
                            </div>
                            <h5 className="opacity-40">Featured Image</h5>
                            <input
                              type="file"
                              className="image_upload_input"
                              onChange={(e) => handleLogoUpload(e)}
                            />
                          </div>
                        ) : (
                          <div className="filled_image">
                            <img
                              src={image}
                              alt="image"
                              className="img-fluid"
                            />
                            <div
                              className="remove_image"
                              onClick={() => setImage(null)}
                            >
                              <i className="mdi mdi-close-thick"></i>
                            </div>
                          </div>
                        )}
                      </div>
                    </div>
                  </div>
                </div>
                <div className="row">
                  <div className="col-md-6">
                    <div className="mb-3">
                      <label>Title</label>
                      <input
                        type="text"
                        className="form-control"
                        placeholder="Enter title"
                        {...register("title", { required: true })}
                      />
                      {errors.title && (
                        <span className="text-danger">Title is required</span>
                      )}
                    </div>
                  </div>
                  <div className="col-md-6">
                    <label>Category</label>
                    {selectedCategory.length > 0 && (
                      <Select
                        mode="multiple"
                        style={{
                          width: "100%",
                          height: 40,
                        }}
                        placeholder="select category"
                        defaultValue={selectedCategory}
                        onChange={handleChangeCategory}
                        optionLabelProp="label"
                        className="custom_selector"
                      >
                        {categories.map((cat, ind) => (
                          <Option value={cat._id} label={cat.title} key={ind}>
                            {cat.title}
                          </Option>
                        ))}
                      </Select>
                    )}
                  </div>
                </div>

                <div className="mb-3">
                  <label>Short Description</label>
                  <textarea
                    type="text"
                    className="form-control"
                    placeholder="Enter short description"
                    {...register("description", { required: true })}
                  />
                  {errors.description && (
                    <span className="text-danger">
                      Short Description is required
                    </span>
                  )}
                </div>
                <div className="mb-3 privacy_editor">
                  <label>News Content</label>
                  <CKEditor
                    editor={ClassicEditor}
                    data={content}
                    style={{ minHeight: "130px" }}
                    onReady={(editor) => {
                      // You can store the "editor" and use when it is needed.
                      console.log("Editor is ready to use!", editor);
                    }}
                    onChange={(event, editor) => {
                      const data = editor.getData();
                      setContent(data);
                      // console.log({ event, editor, data });
                    }}
                    onBlur={(event, editor) => {
                      console.log("Blur.", editor);
                    }}
                    onFocus={(event, editor) => {
                      console.log("Focus.", editor);
                    }}
                  />
                </div>
                <h5 className="mt-4">SEO Meta Tags</h5>
                <hr />
                <div className="mb-3">
                  <label>Meta Title</label>
                  <input
                    type="text"
                    className="form-control"
                    {...register("meta_title", { required: false })}
                    placeholder="Enter title"
                  />
                </div>
                <div className="mb-3">
                  <label>Meta Description</label>
                  <input
                    type="text"
                    className="form-control"
                    {...register("meta_description", { required: false })}
                    placeholder="Enter description"
                  />
                </div>
                <hr />
                <div>
                  <button type="submit" className="btn btn-primary">
                    Update
                  </button>
                </div>
              </form>
            </div>
          </div>
        </Container>
      </div>
    </React.Fragment>
  );
}

export default EditSocialNews;
